//options for upload image in tiptap editor
export enum UploadImageOptionEnum {
  Image = 'image',
  Banner = 'banner',
  Button = 'button'
}
